export default __webpack_public_path__ + "static/media/widget_watchbox_vpmnq1d_buy.9366a761.mp3";